export default {
  primary: "rgb(172, 14, 93)",
  blue: "#3498db",
  gray: "rgb(245, 245, 245)",
  dark: "#001529",
  danger: "#ff4d4f",
  success: "#b0c90b"
};
